import { AiFittingRoomBanner } from '../../../../AiFittingRoomBanner';
import { Flex } from '@banhala/ui-kit';

export const AiFittingRoomSizeButton = () => {
  return (
    <Flex margin={{ top: 8 }}>
      <AiFittingRoomBanner entryPoint="GOODS_DETAIL_SIZE" tab="SIZE" />
    </Flex>
  );
};
